var $ = require('jquery');

$(function () {
    var isValid = true;

    $(".login-form__body__submit")
        .on("click",
            function (e) {
                e.preventDefault();
                isValid = true;
                var formNode = $(this).closest("form");
                var formId = formNode.attr("id");
                var contextLang = formNode.attr("data-contextLang");
                var payload = [];

                setValidationErrorMessage(formNode, false);
                formNode.find('.first-time-pass-reset').hide();

                parseForm(payload, formNode, formId, contextLang);

            });

    function checkInvalid(domElement, isRequired, secondaryValidator, errorSelector) {
        if (isRequired && secondaryValidator) {
            isValid = false;
            $(domElement).attr('data-isInvalid', 'true');
            if (!!errorSelector) {
                if ($(domElement).attr('data-is-invalid-selector')) {
                    $(domElement).attr('data-is-invalid-selector', $(domElement).attr('data-is-invalid-selector') + ',' + errorSelector);
                } else {
                    $(domElement).attr('data-is-invalid-selector', errorSelector);
                }
            }
        }
    }

    function parseForm(payload, formNode, formId, contextLang) {

        formNode.find("[data-formId = '" + formId + "']")
            .each(function () {
                $(this).attr('data-isInvalid', 'false');
                $(this).siblings('.form__field--error').hide();
                var currentItem = {};
                currentItem["label"] = $("label[for='" + $(this).attr('id') + "']").text();
                currentItem["isEmail"] = false;
                //if its a multi checkbox we need to make an array of checkboxes for each value
                if ($(this).hasClass("multi-checkbox__checkboxes__container")) {
                    currentItem["label"] = $(this).find("label").first().text();

                    var multiCheckboxPayload = [];
                    var anyChecked = false;
                    $(this)
                        .find("input[type='checkbox']")
                        .each(function () {
                            var checkbox = {};
                            checkbox["label"] = $("label[for='" + $(this).attr('id') + "']").text();
                            var isChecked = $(this).is(":checked");
                            checkbox["value"] = isChecked;
                            if (!anyChecked && isChecked) {
                                anyChecked = isChecked;
                            }
                            multiCheckboxPayload.push(checkbox);
                        });
                    checkInvalid(this, $(this).data('required'), !anyChecked);

                    currentItem["multivalue"] = multiCheckboxPayload;
                }
                else if ($(this).is("select")) {
                    var selectedValue = $(this).find(":selected").val();
                    checkInvalid(this, $(this).data('required'), selectedValue === "_default");
                    currentItem["value"] = selectedValue;
                }
                    //if its a checkbox we just need to know if its checked
                else if ($(this).is(':checkbox')) {
                    var isChecked = $(this).is(":checked");
                    checkInvalid(this, $(this).data('required'), !isChecked);

                    currentItem["value"] = isChecked;
                }
                    // if its a div then its captcha, ignore
                else if ($(this).is('div')) {
                    return true;
                }
                else {
                    var textValue = $(this).val();
                    var isRequired = $(this).data('required');
                    if ($(this).attr('type') === 'email' && isRequired) {
                        currentItem["isEmail"] = true;
                        checkInvalid(this, true, textValue.length === 0 || !isEmail(textValue));
                    }
                    else if ($(this).attr('type') === 'email' && textValue.length !== 0) {
                        currentItem["isEmail"] = true;
                        checkInvalid(this, true, !isEmail(textValue));
                    }
                    else {
                        checkInvalid(this, $(this).data('required'), textValue.length === 0, '[data-required-error]');
                        checkInvalid(this, $(this).data('regex'), !new RegExp($(this).data('regex')).test(textValue), '[data-regex-error]');
                        checkInvalid(this, $(this).data('maxChars'), textValue.length > $(this).data('maxChars'), '[data-max-chars-error]');
                    }

                    currentItem["value"] = textValue === '$date' ? '$date:' + new Date() : textValue;
                }
                payload.push(currentItem);
            });
        if (!isValid) {
            formNode.find("[data-isInvalid='true']")
                .each(function () {
                    var $this,
                        invalidSelector;

                    $this = $(this);
                    invalidSelector = $this.attr('data-is-invalid-selector');

                    if (!!invalidSelector) {
                        $this.siblings(invalidSelector).show().parent().addClass('form__field--has-error');
                    } else {
                        $(this).closest('.form__field').addClass('form__field--has-error').find('.form__field--error').show();
                    }

                    $this.attr('data-is-invalid-selector', '');
                });
            formNode.find("[data-isInvalid='false']").each(function () {
                $(this).closest('.form__field').removeClass('form__field--has-error').find('.form__field--error').hide();
            });
        } else {

            var email = formNode.find("input[name=Email]");
            var password = formNode.find("input[name=Password]");
            var returnUrl = formNode.find("input[name=ReturnUrl]");
            var itemid = formNode.find("input[name=ItemId]");
   
            $.ajax({
                url: "/api/Sitecore/ProfileManagement/Login",
                type: "POST",
                context: this,
                contentType: "application/json",
                data: JSON.stringify({
                    email: email.val(),
                    password: password.val(),
                    itemid: itemid.val(),
                    returnUrl: returnUrl.val()
                }),
                success: function (data) {
                    if (data) {

                        if (data.isFirstTimePassReset) {
                            formNode.find('.first-time-pass-reset').show();
                            return;
                        } 

                        if (data.isLoggedIn)
                        {
                            window.location.href = returnUrl.val() || data.returnUrl;
                        }
                        else
                        {
                            handleError(formNode);
                        }
                    } else {
                        handleError(formNode);
                    }
                },
                error: function (jqXHR, status, error) {
                    handleError(formNode, jqXHR, status, error);
                }
            });
        }
    }

    function setValidationErrorMessage(formNode, isInvalid)
    {
        if (formNode !== undefined) {
            if (isInvalid) {
                formNode.find(".validation-summary-valid")
                    .each(function () {
                        var $this = $(this);

                        $this.removeClass('validation-summary-valid');
                        $this.addClass('validation-summary-errors');
                    });
            }
            else{
                formNode.find(".validation-summary-errors")
                    .each(function () {
                        var $this = $(this);

                        $this.removeClass('validation-summary-errors');
                        $this.addClass('validation-summary-valid');
                    });
            }
        }
    }

    function handleError(formNode, jqXHR, status, error) {
        setValidationErrorMessage(formNode, true);
    }

    function isEmail(email) {
        var regex =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
    }
});